import { CommonModule } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { MatStepper, MatStepperModule } from '@angular/material/stepper';
import { METHODOLOGIES } from '../../core/constants/methodologies';
import { IMethodology } from '../../core/models/methologie.model';


@Component({
  selector: 'app-methodology',
  templateUrl: './methodology.component.html',
  styleUrls: ['./methodology.component.scss'],
  imports: [
    MatStepperModule,
    CommonModule
  ],
  standalone: true
})
export class MethodologyComponent implements OnInit {
  methodologies = METHODOLOGIES;
  methodologySelected?: IMethodology;
  currentIndex: number = 0;

  constructor() { }

  ngOnInit() {
    this.methodologySelected = this.methodologies[0];
  }

  goToPrevious() {
    if (this.currentIndex > 0) {
      this.currentIndex--;
      this.methodologySelected = this.methodologies[this.currentIndex];
    }
  }

  goToNext() {
    if (this.currentIndex < this.methodologies.length - 1) {
      this.currentIndex++;
      this.methodologySelected = this.methodologies[this.currentIndex];
    }
  }

  get isFirst(): boolean {
    return this.currentIndex === 0;
  }

  get isLast(): boolean {
    return this.currentIndex === this.methodologies.length - 1;
  }

  goToStep(event: any) {
    this.currentIndex = event.selectedIndex;
    this.methodologySelected = this.methodologies[this.currentIndex];
  }

}
